import { Product, SiteReview } from "./product";

/** サイトレビュー変換（null で安全化） */
const buildSiteReview = (src: any): SiteReview | null => {
  if (!src) return null;
  return {
    price: src.price ?? null,
    rating: src.rating ?? null,
    count: src.count ?? null,
    url: src.url ?? null,
  };
};

/** AI 検索カード → Product 共通変換 */
export const mapAiCardsToProducts = (cards: any[]): Product[] => {
  return cards.map((card) => ({
    id: String(card.id),
    title: card.title ?? "不明な商品",
    price: card.price ?? null,
    link: card.link ?? null,
    image: card.image ?? null,

    ai_score: card.ai_score ?? null,
    ai_summary: card.ai_summary ?? null,
    ai_summary_detail: card.ai_summary_detail ?? null,
    ai_pros: card.ai_pros ?? null,
    ai_cons: card.ai_cons ?? null,

    review: {
      yahoo: buildSiteReview(card.review?.yahoo),
      rakuten: buildSiteReview(card.review?.rakuten),
      amazon: buildSiteReview(card.review?.amazon),
    },
  }));
};

/** 通常検索 API → Product 共通変換 */
export const mapRawProductsToProducts = (rows: any[]): Product[] => {
  return rows.map((row) => ({
    id: String(row.id),
    title: row.title ?? "不明な商品",
    price: row.price ?? null,
    link: row.link ?? null,
    image: row.image ?? null,

    ai_score: row.ai_score ?? null,
    ai_summary: row.ai_summary ?? null,
    ai_summary_detail: row.ai_summary_detail ?? null,
    ai_pros: row.ai_pros ?? null,
    ai_cons: row.ai_cons ?? null,

    review: {
      yahoo: buildSiteReview(row.review?.yahoo),
      rakuten: buildSiteReview(row.review?.rakuten),
      amazon: buildSiteReview(row.review?.amazon),
    },
  }));
};
